export const ERROR_HOUSEHOLD_INFORMATION = 'ERROR_HOUSEHOLD_INFORMATION';
export const RECEIVED_HOUSEHOLD_INFORMATION = 'RECEIVED_HOUSEHOLD_INFORMATION';
export const REQUESTED_HOUSEHOLD_INFORMATION =
  'REQUESTED_HOUSEHOLD_INFORMATION';

export const errorHouseholdInformation = (error) => ({
  type: ERROR_HOUSEHOLD_INFORMATION,
  error
});

export const receivedHouseholdInformation = (response) => ({
  type: RECEIVED_HOUSEHOLD_INFORMATION,
  payload: {
    ...response
  }
});

export const requestedHouseholdInformation = () => ({
  type: REQUESTED_HOUSEHOLD_INFORMATION
});
